export const TOGGLE_DARK_MODE = "BEHAVIOR/TOGGLE_DARK_MODE";
export const SET_PLACE_HOLDER = "BEHAVIOR/SET_PLACE_HOLDER";
export const TOGGLE_CHAT = 'BEHAVIOR/TOGGLE_CHAT';
export const TOGGLE_INPUT_DISABLED = 'BEHAVIOR/TOGGLE_INPUT_DISABLED';
export const TOGGLE_MSG_LOADER = 'BEHAVIOR/TOGGLE_MSG_LOADER';
export const ADD_NEW_USER_MESSAGE = 'MESSAGES/ADD_NEW_USER_MESSAGE';
export const ADD_NEW_RESPONSE_MESSAGE = 'MESSAGES/ADD_NEW_RESPONSE_MESSAGE';
export const ADD_NEW_LINK_SNIPPET = 'MESSAGES/ADD_NEW_LINK_SNIPPET';
export const ADD_NEW_MINI_CARD = 'MESSAGES/ADD_NEW_MIN_CARD';
export const ADD_COMPONENT_MESSAGE = 'MESSAGES/ADD_COMPONENT_MESSAGE';
export const DROP_MESSAGES = 'MESSAGES/DROP_MESSAGES';
export const HIDE_AVATAR = 'MESSAGES/HIDE_AVATAR';
export const ADD_QUICK_BUTTONS = 'ADD_QUICK_BUTTONS';
export const SET_QUICK_BUTTON_CLICKED = 'SET_QUICK_BUTTON_CLICKED';
export const PULL_SESSION = 'PULL_SESSION';
export const SET_CONNECTED = 'SET_CONNECTED'
